import { AppMode, getAppMode } from './config/runtimeSettings';

/**
 * API base URL is selected at runtime based on app mode.
 *
 * Optional env vars:
 * - REACT_APP_API_URL_LIVE
 * - REACT_APP_API_URL_TEST
 * Fallback:
 * - REACT_APP_API_URL
 * - http://localhost:3001
 */
const apiBaseURLLive =
    process.env.REACT_APP_API_URL_LIVE || process.env.REACT_APP_API_URL || 'https://honest-art-backend-v2.vercel.app/';
const apiBaseURLTest =
    process.env.REACT_APP_API_URL_TEST || process.env.REACT_APP_API_URL || 'https://honest-art-backend-v2.vercel.app/';

export const getApiBaseURL = (): string => {
    const mode = getAppMode();
    return mode === 'test' ? apiBaseURLTest : apiBaseURLLive;
};

export const getApiBaseURLForMode = (mode: AppMode): string => {
    return mode === 'test' ? apiBaseURLTest : apiBaseURLLive;
};
